import discountQueries from '@apis/queries/discountQueries';
import Column from '@components/Column';
import styled from '@emotion/styled';
import usePriceUnit from '@hooks/item/usePriceUnit';
import useProject from '@hooks/useProject';
import { useFlow } from '@stackflow/react';
import useCalculatedRequest from '@store/order/hooks/useCalculatedRequest';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import SectionTitle from '../common/SectionTitle';
import SelectRow from '../common/SelectRow';

/** 선불카드 */
function PrepaidCardSection() {
    const { t } = useTranslation('order');
    const priceUnit = usePriceUnit();
    const { push } = useFlow();
    const project = useProject();
    const { shopId, prepaidCardAmount } = useCalculatedRequest();
    const { data } = useQuery({
        ...discountQueries.list(shopId),
        enabled: !!shopId,
    });
    const prepaidCardCount = data?.prepaidCardCount || 0;

    if (!project?.features.ppCardEnabled) {
        return null;
    }
    return (
        <Container fullWidth spacing={4}>
            <SectionTitle>{t('prepaidCard.title')}</SectionTitle>
            <SelectRow label={t('prepaidCard.label')}
                ariaLabel='open-prepaid-card-button'
                rightText={prepaidCardCount > 0
                    ? t('prepaidCard.owned', { count: prepaidCardCount })
                    : t('prepaidCard.register')}
                appliedText={prepaidCardAmount > 0 ? t('discount.appliedAmount', {
                    amount: `${prepaidCardAmount.toLocaleString()}${priceUnit}`,
                }) : undefined}
                onClick={() => {
                    // 보유한 선불카드가 없으면 선불카드 화면으로 안내한다
                    if (prepaidCardCount === 0) {
                        push('MyPrepaidCardActivity', {});
                    } else {
                        push('OrderPrepaidCardBottomSheet', {});
                    }
                }} />
        </Container>
    );
}

const Container = styled(Column)`
    padding: var(--spacing-6) var(--spacing-4);
`;

export default PrepaidCardSection;
